export default "__VITE_ASSET__c097ea7a__"